import VerifiedCheck from "@/src/components/GlobalElements/GlobalHeader/components/VerifiedCheck";
import { Subhead5 } from "@/src/components/typography/components/Subhead";
import { SubheadName } from "@/src/components/typography/components/Subhead/types";
import NikeAccountProfileImageHeader from "@/app/(main)/account/settings/components/NikeAccountProfileImageHeader";
import ProfileLabel from "./ProfileLabel";
import { Label9 } from "@/src/components/typography/components/Label";
import { LabelName } from "@/src/components/typography/components/Label/types";
import { formatSwooshHandle } from "@/src/helpers/stringFormatters";
import OptimizelyFeatureFlaggedComponent from "@/src/components/OptimizelyFeatureFlaggedComponent";
import { OptimizelyFeatureFlags } from "@/src/services/optimizely/optimizelyFeatureFlags";

type Props = {
  dateJoined?: string;
  swooshHandle: string;
  image?: string;
};

const SwooshHandleAndImageHeaderWithAchievement: React.FC<Props> = ({
  image,
  dateJoined,
  swooshHandle,
}) => {
  return (
    <NikeAccountProfileImageHeader
      className="gap-2 md:gap-5 flex flex-col md:flex-row"
      image={image}
    >
      <div className="flex h-full flex-col justify-end">
        <div className="flex flex-col gap-[18px] md:gap-6">
          {dateJoined && <ProfileLabel>Joined {dateJoined}</ProfileLabel>}
          <Subhead5
            as={"span"}
            md={SubheadName.Subhead_1}
            className="whitespace-nowrap text-white"
          >
            {formatSwooshHandle(swooshHandle)}
            <OptimizelyFeatureFlaggedComponent
              optimizelyFlags={[OptimizelyFeatureFlags.VERIFIED_PROFILE]}
            >
              <VerifiedCheck className="h-3 w-3 md:h-5 md:w-5" />
            </OptimizelyFeatureFlaggedComponent>
          </Subhead5>
        </div>
      </div>
    </NikeAccountProfileImageHeader>
  );
};

export default SwooshHandleAndImageHeaderWithAchievement;
